import { Linkedin, Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import CeccaLogo from "./CeccaLogo";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground text-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-8 mb-8">
          {/* Company Info */}
          <div className="text-center sm:text-left">
            <Link to="/" aria-label="CECCA Rådgivning – gå til forsiden" className="inline-block mb-4">
              <CeccaLogo className="h-10" textColor="#ffffff" />
            </Link>
            <p className="text-background/80 text-sm mb-6 max-w-xs mx-auto sm:mx-0">
              Din uvildige rådgiver ved større skader. Vi hjælper med brandskader, 
              forsikringsopgørelser, ejerskifte, indbo og driftstab – fra start til slut.
            </p>
            <div className="flex gap-2 justify-center sm:justify-start">
              <a
                href="https://www.facebook.com/ceccaaps/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full bg-background/10 flex items-center justify-center text-background/80 hover:bg-accent hover:text-foreground active:scale-95 transition-all"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="https://www.instagram.com/cecca_raadgivning/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full bg-background/10 flex items-center justify-center text-background/80 hover:bg-accent hover:text-foreground active:scale-95 transition-all"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/cecca-r%C3%A5dgivning/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full bg-background/10 flex items-center justify-center text-background/80 hover:bg-accent hover:text-foreground active:scale-95 transition-all"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="text-center sm:text-left">
            <h4 className="font-semibold mb-4">Hurtige links</h4>
            <ul className="space-y-1">
              <li>
                <Link 
                  to="/" 
                  className="inline-block py-2 px-1 text-sm text-background/80 hover:text-accent active:text-accent/80 transition-colors"
                >
                  Hjem
                </Link>
              </li>
              <li>
                <Link 
                  to="/cases" 
                  className="inline-block py-2 px-1 text-sm text-background/80 hover:text-accent active:text-accent/80 transition-colors"
                >
                  Cases
                </Link>
              </li>
              <li>
                <a 
                  href="/#faq" 
                  className="inline-block py-2 px-1 text-sm text-background/80 hover:text-accent active:text-accent/80 transition-colors"
                >
                  FAQ
                </a>
              </li>
              <li>
                <Link 
                  to="/om-os" 
                  className="inline-block py-2 px-1 text-sm text-background/80 hover:text-accent active:text-accent/80 transition-colors"
                >
                  Om os
                </Link>
              </li>
              <li>
                <Link 
                  to="/tilgang" 
                  className="inline-block py-2 px-1 text-sm text-background/80 hover:text-accent active:text-accent/80 transition-colors"
                >
                  Vores tilgang
                </Link>
              </li>
              <li>
                <Link 
                  to="/job-karriere" 
                  className="inline-block py-2 px-1 text-sm text-background/80 hover:text-accent active:text-accent/80 transition-colors"
                >
                  Job & Karriere
                </Link>
              </li>
            </ul>
          </div>

          <div className="text-center sm:text-left">
            <h4 className="font-semibold mb-4">Services</h4>
            <ul className="space-y-1">
              <li>
                <Link 
                  to="/brand-vand-storm-sneskader" 
                  className="inline-block py-2 px-1 text-sm text-background/80 hover:text-accent active:text-accent/80 transition-colors"
                >
                  Brand-, vand-, storm- og sneskader
                </Link>
              </li>
              <li>
                <Link 
                  to="/forsikringsopgoerelser" 
                  className="inline-block py-2 px-1 text-sm text-background/80 hover:text-accent active:text-accent/80 transition-colors"
                >
                  Forsikringsopgørelser og taksering
                </Link>
              </li>
              <li>
                <Link 
                  to="/myndighedskontakt"
                  className="inline-block py-2 px-1 text-sm text-background/80 hover:text-accent active:text-accent/80 transition-colors"
                >
                  Myndighedskontakt
                </Link>
              </li>
              <li>
                <Link 
                  to="/nedrivning-sanering-genopbygning"
                  className="inline-block py-2 px-1 text-sm text-background/80 hover:text-accent active:text-accent/80 transition-colors"
                >
                  Nedrivning, sanering og genopbygning
                </Link>
              </li>
              <li>
                <Link 
                  to="/renovering-ombygning"
                  className="inline-block py-2 px-1 text-sm text-background/80 hover:text-accent active:text-accent/80 transition-colors"
                >
                  Renovering og ombygning
                </Link>
              </li>
              <li>
                <Link
                  to="/indbo-driftstab"
                  className="inline-block py-2 px-1 text-sm text-background/80 hover:text-accent active:text-accent/80 transition-colors"
                >
                  Indbo, inventar, løsøre og driftstab
                </Link>
              </li>
              <li>
                <Link
                  to="/byggestyring"
                  className="inline-block py-2 px-1 text-sm text-background/80 hover:text-accent active:text-accent/80 transition-colors"
                >
                  Byggestyring
                </Link>
              </li>
              <li>
                <Link
                  to="/ejerskifteforsikring"
                  className="inline-block py-2 px-1 text-sm text-background/80 hover:text-accent active:text-accent/80 transition-colors"
                >
                  Ejerskifte
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="text-center sm:text-left">
            <h4 className="font-semibold mb-4">Kontakt</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="tel:+4593889029" 
                  className="inline-flex items-center gap-3 py-2.5 px-4 -mx-4 sm:mx-0 sm:px-0 rounded-lg text-background/90 hover:text-accent hover:bg-background/5 active:bg-background/10 transition-all w-full sm:w-auto justify-center sm:justify-start"
                >
                  <Phone className="h-4 w-4 flex-shrink-0" />
                  <span className="text-sm font-medium">+45 93 88 90 29</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:cp@cecca.dk" 
                  className="inline-flex items-center gap-3 py-2.5 px-4 -mx-4 sm:mx-0 sm:px-0 rounded-lg text-background/90 hover:text-accent hover:bg-background/5 active:bg-background/10 transition-all w-full sm:w-auto justify-center sm:justify-start"
                >
                  <Mail className="h-4 w-4 flex-shrink-0" />
                  <span className="text-sm font-medium">cp@cecca.dk</span>
                </a>
              </li>
              <li>
                <a 
                  href="https://www.google.com/maps/search/?api=1&query=Drosselvej+2,+6640+Lunderskov,+Denmark"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-start gap-3 py-2.5 px-4 -mx-4 sm:mx-0 sm:px-0 rounded-lg text-background/90 hover:text-accent hover:bg-background/5 active:bg-background/10 transition-all w-full sm:w-auto justify-center sm:justify-start"
                >
                  <MapPin className="h-4 w-4 flex-shrink-0 mt-0.5" />
                  <span className="text-sm font-medium">
                    Drosselvej 2<br />
                    6640 Lunderskov
                  </span>
                </a>
              </li>
              <li className="text-background/50 text-xs pt-1">
                CVR: 44589842
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-background/20">
          <div className="flex flex-col gap-6 sm:flex-row sm:justify-between sm:items-center text-sm text-background/70">
            <p className="text-center sm:text-left">© {currentYear} Cecca. Alle rettigheder forbeholdt.</p>
            <div className="flex flex-wrap justify-center sm:justify-end gap-x-1 gap-y-2">
              <Link 
                to="/privatlivspolitik" 
                className="inline-block py-2 px-3 rounded-lg hover:text-accent hover:bg-background/5 active:bg-background/10 transition-all"
              >
                Privatlivspolitik
              </Link>
              <Link 
                to="/cookiepolitik" 
                className="inline-block py-2 px-3 rounded-lg hover:text-accent hover:bg-background/5 active:bg-background/10 transition-all"
              >
                Cookiepolitik
              </Link>
              <Link 
                to="/handelsbetingelser" 
                className="inline-block py-2 px-3 rounded-lg hover:text-accent hover:bg-background/5 active:bg-background/10 transition-all"
              >
                Handelsbetingelser
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
